import React from 'react';
import classnames from 'classnames';
import s from './AvatarPlaceholder.scss';

export interface Props {
  userId?: number;
  className?: string;
  width?: number | string;
  height?: number | string;
  alt?: string;
  isGroup?: boolean;
  'aria-hidden'?: React.AriaAttributes['aria-hidden'];
}

const AvatarPlaceholder: React.FC<Props> = ({
  className,
  isGroup,
  width,
  height,
  'aria-hidden': ariaHidden,
  alt,
  userId,
}) => {
  const icon = isGroup ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 12"
      role="img"
      aria-label={alt}
    >
      <title>{alt}</title>
      <path d="M9.65 2.65a2.65 2.65 0 11-5.3 0 2.65 2.65 0 015.3 0zM3.14 1c.133 0 .263.011.39.032a3.728 3.728 0 00-.483 1.84c0 1.012.401 1.93 1.053 2.604A2.34 2.34 0 113.14 1zM2.625 7l.915.009a.263.263 0 01.238.368l-1.521 3.468a.262.262 0 01-.24.157h-.95a.466.466 0 01-.33-.13 14.04 14.04 0 01-.568-.605c-.115-.131-.123-.285-.036-.436L1.608 7.26a.5.5 0 01.427-.252L2.625 7zM5.37 7.312c.08-.183.259-.3.458-.3h2.346a.5.5 0 01.458.3l1.512 3.435a.5.5 0 01-.032.464l-.34.552a.5.5 0 01-.426.237H4.654a.5.5 0 01-.425-.237l-.335-.542a.513.513 0 01-.03-.482c.34-.749 1.182-2.681 1.506-3.427zM11.375 7l-.915.009a.263.263 0 00-.238.368l1.522 3.468a.262.262 0 00.24.157h.95a.466.466 0 00.33-.13c.181-.18.412-.43.567-.605.115-.131.123-.285.037-.436L12.392 7.26a.5.5 0 00-.427-.252L11.375 7zM10.86 1c-.133 0-.263.011-.39.032.308.544.483 1.172.483 1.84 0 1.012-.401 1.93-1.053 2.604A2.34 2.34 0 1010.86 1z"></path>
    </svg>
  ) : (
    <svg
      width={200}
      height={200}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={alt}
    >
      <title>{alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.157 25L121.687 43.18L149.865 43.0922L154.672 70.8578L176.314 88.9033L162.149 113.263L167.128 140.998L140.619 150.553L126.606 175L100.157 165.28L73.7079 175L59.6947 150.553L33.1857 140.998L38.1652 113.263L24 88.9033L45.6423 70.8578L50.449 43.0922L78.6275 43.18L100.157 25ZM100.157 49.3631L85.4103 61.8155L66.1094 61.7554L62.817 80.7736L47.993 93.1339L57.6955 109.819L54.2847 128.816L72.4422 135.361L82.0406 152.106L100.157 145.448L118.273 152.106L127.872 135.361L146.029 128.816L142.619 109.819L152.321 93.1339L137.497 80.7736L134.205 61.7554L114.904 61.8155L100.157 49.3631Z"
        fill="#06070D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.5297 79.0236L95.6599 82.9093L97.9542 90.6988L94.0684 97.829L86.279 100.123L79.1488 96.2375L76.8545 88.4481L80.7402 81.3178L88.5297 79.0236Z"
        fill="#06070D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.105 79.0236L128.235 82.9093L130.529 90.6988L126.643 97.829L118.854 100.123L111.724 96.2375L109.43 88.4481L113.315 81.3178L121.105 79.0236Z"
        fill="#06070D"
      />
    </svg>
  );

  // assign a random background color based on userId
  const randomBgBucket = userId ? userId % 3 : 0;

  return (
    <div
      className={classnames(
        s['root'],
        !isGroup && s['is-user'],
        !isGroup && s[`bg-bucket-${randomBgBucket}`],
        isGroup && s['is-group'],
        className
      )}
      style={{ width, height }}
      aria-hidden={ariaHidden}
    >
      {icon}
    </div>
  );
};
AvatarPlaceholder.displayName = 'AvatarPlaceholder';

export default AvatarPlaceholder;
